import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { PendingDocuments } from "components/upload-documents/pending-documents";
import {
  cancelProcessingAction,
  fetchPendingDocumentsAction,
  focusPendingDocumentAction,
  savePendingDocumentAction,
  savePendingOtherDocumentAction,
  setTrashDocumentVisibilityAction,
  trashPendingDocumentAction,
  processAllDocumentsAction,
  cancelProcessingAllDocumentsAction,
  reprocessPendingDocumentAction,
  changeDocumentTypeAction,
  startFiltersModeAction,
  endFiltersModeAction,
  addSourceFilterAction,
  removeSourceFilterAction,
  addStuckStatusFilterAction,
  removeStuckStatusFilterAction
} from "actions/pending-documents-actions";
import { createCategoryAction } from "actions/categories-actions";
import { trackPageAction } from "actions/shared/tracking-actions";
import { documentPropType } from "custom-prop-types";
import { Loading } from "components/common/loading";

class PendingDocumentsPage extends React.Component {
  componentWillMount() {
    if (this.props.pendingDocuments.length === 0) {
      this.props.init(this.props.accountId);
    }
    this.props.trackPage();
  }
  render() {
    if (this.props.isLoading) {
      return <Loading />;
    }
    return (
      <div>
        <PendingDocuments { ...this.props } />
      </div>
    );
  }
}

PendingDocumentsPage.propTypes = {
  accountId: PropTypes.string.isRequired,
  init: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  pendingDocuments: PropTypes.arrayOf(documentPropType),
  trackPage: PropTypes.func.isRequired
};

PendingDocumentsPage.defaultProps = {
  pendingDocuments: []
};

const mapStateToProps = (state) => ({
  accountId: state.app.selectedAccount.id,
  accountSlug: state.app.selectedAccount.slug,
  categories: state.categories.categories,
  currencies: state.currencies.currencies,
  documentType: state.pendingDocuments.documentType,
  focusedDocument: state.pendingDocuments.focusedDocument,
  isBeingCancelled: state.pendingDocuments.isBeingCancelled,
  isCancelProcessingLoading: state.pendingDocuments.isCancelProcessingLoading,
  isCancelProcessingVisible: state.pendingDocuments.isCancelProcessingVisible,
  isFiltersMode: state.pendingDocuments.isFiltersMode,
  isLoading: state.pendingDocuments.isLoading,
  isTrashDocumentVisible: state.pendingDocuments.isTrashDocumentVisible,
  pendingDocuments: state.pendingDocuments.pendingDocuments,
  preferredCurrency: state.app.selectedAccount.preferredCurrency,
  sourceFilter: state.pendingDocuments.sourceFilter,
  statusFilter: state.pendingDocuments.statusFilter,
  taxRate: state.accountSettings.vat,
  vendors: state.vendors.vendors
});

const mapDispatchToProps = (dispatch) => ({
  init: (accountId) => dispatch(fetchPendingDocumentsAction(accountId)),
  trackPage: () => dispatch(trackPageAction("Awaiting processing page")),
  onAddSourceFilter: (filter) => dispatch(addSourceFilterAction(filter)),
  onAddStuckStatusFilter: (filter) => dispatch(addStuckStatusFilterAction(filter)),
  onCancelProcessing: (document) => dispatch(cancelProcessingAction(document)),
  onCancelProcessingAllDocuments: (pendingDocuments) => dispatch(cancelProcessingAllDocumentsAction(pendingDocuments)),
  onChangeDocumentType: (type) => dispatch(changeDocumentTypeAction(type)),
  onCreateCategory: (accountId, category) => dispatch(createCategoryAction(accountId, category)),
  onEndFiltersMode: () => dispatch(endFiltersModeAction()),
  onFocusDocument: (document) => dispatch(focusPendingDocumentAction(document)),
  onHideTrashDocument: () => dispatch(setTrashDocumentVisibilityAction(false)),
  onProcessAllDocuments: (pendingDocuments) => dispatch(processAllDocumentsAction(pendingDocuments)),
  onRemoveSourceFilter: (accountId) => dispatch(removeSourceFilterAction(accountId)),
  onRemoveStuckStatusFilter: (accountId) => dispatch(removeStuckStatusFilterAction(accountId)),
  onReprocessPendingDocument: (document) => dispatch(reprocessPendingDocumentAction(document)),
  onSavePendingOtherDocument: () => dispatch(savePendingOtherDocumentAction()),
  onSavePendingDocument: () => dispatch(savePendingDocumentAction()),
  onShowTrashDocument: () => dispatch(setTrashDocumentVisibilityAction(true)),
  onStartFiltersMode: () => dispatch(startFiltersModeAction()),
  onTrashPendingDocument: (accountId, document) => dispatch(trashPendingDocumentAction(accountId, document))
});

export const PendingDocumentsContainer = connect(mapStateToProps, mapDispatchToProps)(PendingDocumentsPage);



// WEBPACK FOOTER //
// ./src/js/containers/pending-documents-container.jsx